import {memo} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';

interface CardCoverImageProps {
  src: string;
  alt: string;
}

export const CardCoverImage = memo(({src, alt}: CardCoverImageProps) => {
  return <Image src={src} alt={alt} />;
});

const Image = styled.img`
  height: 200px;
  aspect-ratio: 1/1;
  object-fit: cover;
  flex-shrink: 0;
  z-index: 3;
  display: block;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: 120px;
    width: 100%;
    aspect-ratio: 16/9;
  }
`;
